var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicControlOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E84B40;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M868.4,473.7h-89.5c0,39.2-8.2,75.5-22.9,107.9l64.7,64.7C850.8,595,868.4,536.3,868.4,473.7z M657.1,482.4 c0-2.9,0.8-5.8,0.8-8.7V157.9C657.9,70.5,587.1,0,500,0S342.1,70.5,342.1,157.9v9.7L657.1,482.4z M93.4,52.6l-67.1,67.1l316.3,316.3 v37.9c0,87.1,70.3,157.9,157.4,157.9c11.8,0,23.2-1.6,34.2-3.9l87.4,87.4c-37.6,17.4-78.9,27.1-121.6,27.1 c-145.3,0-278.9-110.5-278.9-268.4h-89.5c0,179.7,143.2,328.2,315.8,353.7V1000h105.3V827.4c47.6-7.1,92.9-23.7,133.7-47.6 L906.6,1000l67.1-66.8L93.4,52.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicControlOff);
export default __webpack_public_path__ + "static/media/micControlOff.fd86cfc4dc1c6f56f859ad7127ddcf1d.svg";
export { ForwardRef as ReactComponent };